// extracted by mini-css-extract-plugin
module.exports =  {"commentIcon":"CommentIcon__commentIcon--Ty"};